import AjaxRequest from "./AjaxRequest";

export default class Cart {
    getCart(user_id) {
        return new AjaxRequest().get(`user/${user_id}/cart`);
    }

    getDetailedCart(user_id, data) {
        return new AjaxRequest().get(`user/${user_id}/cart/detailed`, data);
    }

    getUsed(user_id) {
        return new AjaxRequest().get(`user/${user_id}/used`);
    }

    getRushProcessing(data) {
        return new AjaxRequest().get("cart/rush", data);
    }

    getShipping(data) {
        return new AjaxRequest().get(`cart/shipping`, data);
    }

    getTax(data) {
        return new AjaxRequest().get(`cart/tax`, data);
    }

    getInternal(data) {
        return new AjaxRequest().post(`cart/internal`, data);
    }

    submitAuthnet(data) {
        return new AjaxRequest().post(`cart/submit-authnet`, data);
    }

    addItem(data, user_id) {
        return new AjaxRequest().post(`user/${user_id}/cart`, data);
    }

    removeItem(data, user_id) {
        return new AjaxRequest().patch(`user/${user_id}/cart`, data);
    }

    setCartCompletion(data, user_id) {
        return new AjaxRequest().patch(`user/${user_id}/cart/complete`, data);
    }

    checkDiscount(data) {
        return new AjaxRequest().post(`discount`, data);
    }

    hasDiscount(user_id) {
        return new AjaxRequest().get(`user/${user_id}/cart/hasdiscount`);
    }

    addDiscount(data, user_id) {
        return new AjaxRequest().post(`user/${user_id}/cart/adddiscount`, data);
    }

    removeDiscount(user_id) {
        return new AjaxRequest().patch(`user/${user_id}/cart/removediscount`);
    }

    checkRetouching(user_id) {
        return new AjaxRequest().get(`user/${user_id}/cart/retouching`);
    }

    checkPrices(data, user_id) {
        return new AjaxRequest().post(`user/${user_id}/cart/pricecheck`, data);
    }

    checkVoucher(data, user_id) {
        return new AjaxRequest().post(
            `user/${user_id}/cart/vouchercheck`,
            data
        );
    }

    checkCutOffDate(data) {
        return new AjaxRequest().get("cart/past-cutoff-date", data);
    }
}
